import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Header from "../../component/users/Header";
import { useSelector } from "react-redux";
import {
  Backdrop,
  Box,
  Container,
  CircularProgress,
  Typography,
} from "@mui/material";
import Footer from "../../component/users/Footer";
import { getProfessionalTournament } from "../../api/getProfessionalTournamentUser";
import { toast } from "react-toastify";
import Info from "../../component/users/ProfessionalTournament/Info";
import Leaderboard from "../../component/users/ProfessionalTournament/Leaderboard";

const ProfessionalTournament = () => {
  const { id } = useParams();
  const token = useSelector((state) => state.auth.token);
  const [tournamentData, setTournamentData] = useState();
  const [loading, setLoading] = useState(true);

  const user = useSelector((state) => state.user.loading);

  const fetchTournamentData = async (id) => {
    try {
      setLoading(true);
      const res = await getProfessionalTournament(id, token);

      if (res.success) {
        setTournamentData(res.data);
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchTournamentData(id);
    }
  }, [id, user]);

  // "";

  return (
    <>
      <Header />
      {user ? (
        <Backdrop
          sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
          open={loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : (
        <Box className="userLayout">
          <Container
            disableGutters={true}
            maxWidth="lg"
            sx={{ background: "#242743", paddingBottom: "0px" }}
          >
            {loading ? (
              <Backdrop
                sx={(theme) => ({
                  color: "#fff",
                  zIndex: theme.zIndex.drawer + 1,
                })}
                open={loading}
              >
                <CircularProgress color="inherit" />
              </Backdrop>
            ) : (
              <Box className="leader-board-main">
                <Box className="leader-board-wrapper">
                  <Box className="heading">
                    <Typography component="h1">
                      {tournamentData.title}
                    </Typography>
                  </Box>
                  <Box sx={{ overflow: "auto" }}>
                    <Box
                      sx={{
                        padding: "20px 30px",
                        display: "flex",
                        flexGrow: "1",
                        flexDirection: "column",
                      }}
                    >
                      <Info tournamentData={tournamentData} />
                    </Box>
                    <Leaderboard
                      goals={tournamentData.professionalTournamentGoals}
                      setTournamentData={setTournamentData}
                    />
                  </Box>
                </Box>
              </Box>
            )}
          </Container>
          <Footer />
        </Box>
      )}
    </>
  );
};

export default ProfessionalTournament;
